const switchableSections = document.querySelectorAll('.switchableSection ');

const TOGGLED_BTN_CLASS = 'switchableSection__button--active';
const TOGGLED_ITEM_CLASS = 'switchableSection__item--active';

if (switchableSections) {
    switchableSections.forEach((section) => {
        const switchableSectionBtns = section.querySelectorAll('.switchableSection__button');
        const switchableSectionItems = section.querySelectorAll('.switchableSection__item');
        if (switchableSectionBtns && switchableSectionItems) {
            switchableSectionBtns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    switchableSectionBtns.forEach((b) => {
                        b.classList.remove(TOGGLED_BTN_CLASS);
                    });

                    switchableSectionItems.forEach((item) => {
                        item.classList.remove(TOGGLED_ITEM_CLASS);
                    });

                    if (!btn.classList.contains(TOGGLED_BTN_CLASS)) {
                        btn.classList.add(TOGGLED_BTN_CLASS);
                        Array.from(switchableSectionItems)
                            .find((el) => el.dataset.form === btn.dataset.form)
                            .classList.add(TOGGLED_ITEM_CLASS);
                    }
                });
            });
        }
    });
}
